import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary"
          style={{
            minHeight: "100vh",
            background: "#050505",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "24px",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <h1 style={{ fontSize: "28px", marginBottom: "12px" }}>Er ging iets mis</h1>
          <p style={{ color: "#a1a1aa", maxWidth: "420px", marginBottom: "24px" }}>
            De pagina kon niet correct geladen worden. Ververs de pagina om het opnieuw te
            proberen.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: "#FF1A1A",
              color: "#fff",
              border: "none",
              padding: "14px 28px",
              fontSize: "15px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Pagina verversen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
